import React from 'react';
import { DialogUI } from '../Interface';

import { Box } from '@mui/material';
import { SimpleTaskListPage } from './SimpleTaskListPage';

const SimpleTaskListDialog = ({ open, handleClose, task, setTaskChanged }) => {
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Eseti feladat felvevő"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <Box mt="1rem">
        <SimpleTaskListPage open={open} data={task} handleClose={handleClose} setTaskChanged={setTaskChanged} />
      </Box>
    </DialogUI>
  );
};

export default SimpleTaskListDialog;
